<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <p>Elige las columnas que deseas mostrar en la exporatación de datos.</p>
    <form @submit.prevent="submit()" autocomplete="off">
      <div class="row mb-3">
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="brand" v-model.trim.lazy="brand">
            <label class="custom-control-label" for="brand">Marca</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="model" v-model.trim.lazy="model">
            <label class="custom-control-label" for="model">Modelo</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="capacity" v-model.trim.lazy="capacity">
            <label class="custom-control-label" for="capacity">Capacidad</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="color" v-model.trim.lazy="color">
            <label class="custom-control-label" for="color">Color</label>
          </div>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="ean" v-model.trim.lazy="ean">
            <label class="custom-control-label" for="ean">EAN</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="nQuotas" v-model.trim.lazy="nQuotas">
            <label class="custom-control-label" for="nQuotas">Nº Cuotas</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="stock" v-model.trim.lazy="stock">
            <label class="custom-control-label" for="stock">Stock</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row mb-2" @click="openAdditionalDataFunc()">
            <div class="col-12">
              <h6 class="float-left mr-3">Campos adicionales</h6>
              <v-icon v-if="!openAdditionalData" name="hi-solid-chevron-down" scale="1.1" />
              <v-icon v-if="openAdditionalData" name="fa-chevron-up" scale="1.2" />
            </div>
          </div>
          <div class="row mb-3" v-if="openAdditionalData">
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="campo1" v-model.trim.lazy="campo1">
                <label class="custom-control-label" for="campo1">Campo 1</label>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="campo2" v-model.trim.lazy="campo2">
                <label class="custom-control-label" for="campo2">Campo 2</label>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="campo3" v-model.trim.lazy="campo3">
                <label class="custom-control-label" for="campo3">Campo 3</label>
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="campo4" v-model.trim.lazy="campo4">
                <label class="custom-control-label" for="campo4">Campo 4</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 pt-3 pl-0">
        <div class="col-12">
          <button class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
          <button class="btn btn-primary generalPrimaryButton float-right">Exportar</button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import axios from 'axios';
import Modal from '../../../Shared/Modal.vue';

export default {
  name: 'ExportData',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'filters',
    'order',
  ],
  data() {
    return {
      classes: this.class,
      brand: true,
      model: true,
      capacity: true,
      color: true,
      ean: true,
      nQuotas: true,
      stock: true,
      openAdditionalData: false,
    };
  },
  components: {
    Modal,
  },
  methods: {
    openAdditionalDataFunc() {
      this.openAdditionalData = !this.openAdditionalData;
    },
    submit() {
      const bodyToSend = {
        filters: this.filters,
        order: this.order,
        columns: []
      }
      //Cambiar por la integracion del servicio final cuando este
      axios.post('https://modyo.vass.es/ok', bodyToSend)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
